import * as Yup from 'yup'

export const credentialsRetailSchema = Yup.object().shape({
  phone: Yup.object().shape({
    code: Yup.string().required('Please provide phone number'),
    number: Yup.string().required('Please provide phone number'),
  }),
})
